module.exports = __webpack_public_path__ + "static/media/20160701_141757.ad5e5c64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20160701_141757.jpg
// module id = 451
// module chunks = 0